var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_c(_vm.isSubcategoryPage ? 'SubcategoryPage' : 'ListPage',{tag:"component",attrs:{"data":_vm.data,"category":_vm.category},on:{"search":_vm.onSearch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }